/* eslint-disable */
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { CheckSquareOutlined, InboxOutlined } from '@ant-design/icons';
import excel from 'assets/images/icons/excel.svg';
import ErrorModal from 'pages/comptroller/ErrorModal';

import { Button, Col, Flex, Form, Popover, Row, Upload } from 'antd';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useGetAllIdentityCaseMutation } from 'store/features/process/processApi';
import { exportExcelFile, handleFileUpload } from 'pages/globals/FileUploadExcel';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import dayjs from 'dayjs';
import { formatNumber } from '../leaseRecordTable';

const { Dragger } = Upload;

const LeaseBulkUpload = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const { state } = useLocation();
	const [show, setShow] = useState(false);
	const [excelData, setExcelData] = useState([]);
	const [modalInfo, setModalInfo] = useState(null);
	const [excelTable, setExcelTable] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [filesubmitButton, setFileSubmitButton] = useState(false);

	const [UploadBulkIdentityCase, { error: errorData, isSuccess: isBulkCaseSuccess, isError: isBulkCaseError }] = useGetAllIdentityCaseMutation();

	const onFinish = (values) => {};

	const transformErrors = (errorObj, index) => {
		return Object.entries(errorObj).map(([field, message]) => ({ DataIndex: index, field, message }));
	};
	function formatDecimal(number) {
		return Number(number).toFixed(2);
	}
	useEffect(() => {
		// Check if every item's remark is valid.
		const allValid = excelTable.every((item) => {
			return item['Remarks'].valid;
		});

		// Set the submit button state based on that check.
		setFileSubmitButton(!allValid);
	}, [excelTable]);

	function parseAndFormatExcelDate(excelDate) {
		const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
		const EXCEL_START_DATE = new Date(1900, 0, 1);

		// Adjust for Excel's leap year bug
		const daysToAdd = excelDate > 59 ? excelDate - 1 : excelDate;

		// Convert to JavaScript Date
		const date = new Date(EXCEL_START_DATE.getTime() + daysToAdd * MILLISECONDS_PER_DAY);

		// Format the date
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		let day = String(date.getDate()).padStart(2, '0');
		day = String(+day - 1);

		return `${year}-${month}-${day}`;
	}

	const getModifiedData = (data) => {
		// Create a mapping from Lease Id to a sequential Data No.
		const leaseIdToDataNo = {};
		let dataNoCounter = 1;

		return data.map((item) => {
			const leaseId = item['Lease Id'];

			// Assign a new Data No. if this Lease Id is encountered for the first time.
			if (!leaseIdToDataNo.hasOwnProperty(leaseId)) {
				leaseIdToDataNo[leaseId] = dataNoCounter;
				dataNoCounter++;
			}

			// Build the remarks object with keys for each error field.
			let remarks = {};

			// Required fields that must be non-empty for every row:
			if (item['Payment Frequency'] === '' || item['Payment Frequency'] === undefined) {
				remarks['Payment Frequency'] = 'Payment Frequency is required';
			} else if (item['Payment Frequency'] !== 'Monthly' && item['Payment Frequency'] !== 'Quarterly') {
				remarks['Payment Frequency'] = 'Payment Frequency must be either Monthly or Quarterly';
			}
			if (!item['Lease Start Date (YYYY-MM-DD)']) {
				remarks['Lease Start Date (YYYY-MM-DD)'] = 'Lease Start Date (YYYY-MM-DD) is required';
			}
			if (!item['Lease Effective Date (YYYY-MM-DD)']) {
				remarks['Lease Effective Date (YYYY-MM-DD)'] = 'Lease Effective Date (YYYY-MM-DD) is required';
			}
			if (item['Lease Term'] === '' || item['Lease Term'] === undefined) {
				remarks['Lease Term'] = 'Lease Term is required';
			} else if (isNaN(Number(item['Lease Term']))) {
				remarks['Lease Term'] = 'Lease Term must be a number';
			}

			if (item['Monthly Gross-Rent'] === '' || item['Monthly Gross-Rent'] === undefined) {
				remarks['Monthly Gross-Rent'] = 'Monthly Gross-Rent is required';
			} else if (isNaN(Number(item['Monthly Gross-Rent']))) {
				remarks['Monthly Gross-Rent'] = 'Monthly Gross-Rent must be a number';
			}
			// if (item['Security Deposit'] === '' || item['Security Deposit'] === undefined) {
			// 	remarks['Security Deposit'] = 'Security Deposit is required';
			// }
			if (item['Incremental Borrowing Rate'] === '' || item['Incremental Borrowing Rate'] === undefined) {
				remarks['Incremental Borrowing Rate'] = 'Incremental Borrowing Rate is required';
			} else if (isNaN(Number(item['Incremental Borrowing Rate']))) {
				remarks['Incremental Borrowing Rate'] = 'Incremental Borrowing Rate must be a number';
			}
			if (item['Escalation (%)'] === '' || item['Escalation (%)'] === undefined) {
				remarks['Escalation (%)'] = 'Escalation (%) is required';
			} else if (isNaN(Number(item['Escalation (%)']))) {
				remarks['Escalation (%)'] = 'Escalation (%) must be a number';
			}
			if (item['Advance Duration'] === '' || item['Advance Duration'] === undefined) {
				remarks['Advance Duration'] = 'Advance Duration is required';
			} else if (isNaN(Number(item['Advance Duration']))) {
				remarks['Advance Duration'] = 'Advance Duration must be a number';
			}
			if (item['Advance Amount'] === '' || item['Advance Amount'] === undefined) {
				remarks['Advance Amount'] = 'Advance Amount is required';
			} else if (isNaN(Number(item['Advance Amount']))) {
				remarks['Advance Amount'] = 'Advance Amount must be a number';
			}
			if (item['Payment Modality'] === '' || item['Payment Modality'] === undefined) {
				remarks['Payment Modality'] = 'Payment Modality is required';
			} else if (item['Payment Modality'].toLowerCase() !== 'advance basis' && item['Payment Modality'].toLowerCase() !== 'accrual basis') {
				remarks['Payment Modality'] = 'Payment Modality must be either Advance Basis or Accrual Basis';
			}

			if (Object.keys(remarks).length === 0) {
				remarks = { valid: true };
			}

			return {
				'Data No.': leaseIdToDataNo[leaseId],
				...item,
				Remarks: remarks,
			};
		});

		// return latestData;
	};

	const validateData = (data) => {
		// data: uploaded excel data

		const defaultKeys = Object.keys(exportData[0]);
		for (let i = 0; i < data?.length; i++) {
			let obj = data[i];
			const keys = Object.keys(obj);
			for (let j = 0; j < defaultKeys?.length; j++) {
				if (!keys.includes(defaultKeys[j])) {
					data[i][defaultKeys[j]] = '';
				}
			}
		}

		setExcelData(data);
		const tableData = getModifiedData(data);
		tableData.sort((a, b) => a['Data No.'] - b['Data No.']);

		setExcelTable(tableData);
	};
	const formatDate = (dateStr) => {
		if (typeof dateStr !== 'string') return '';
		let [year, month, day] = dateStr.split('-').map((num) => num.padStart(2, '0'));
		// if (+day < 10 || !day.includes('0')) day = '0' + day;
		return `${year}-${month}-${day}`;
	};
	const formatEffectiveDate = (dateStr) => {
		if (typeof dateStr !== 'string') return '';
		let [year, month, day] = dateStr.split('-').map((num) => num.padStart(2, '0'));
		if (+day < 10 && !day.includes('0')) day = '0' + day;
		return `${year}-${month}-${day}`;
	};
	const handleExcelSubmit = () => {
		setModalInfo({
			head: 'Lease Bulk Upload',
			action: 'submit',
			activationStatus: 'create new lease records',
		});

		setShowModal(true);
		setShow(false);
	};

	function calculateMonthDifference(effectiveDateInput, startDateInput) {
		const effectiveDate = dayjs(effectiveDateInput);

		const startDate = dayjs(startDateInput);

		let monthDifference = (effectiveDate.year() - startDate.year()) * 12 + (effectiveDate.month() - startDate.month());
		monthDifference += 1;

		// Ensure non-negative
		if (monthDifference < 0) {
			monthDifference = 0;
		}

		return monthDifference;
	}

	const getDateParts = (date) => {
		// if (!(date instanceof Date)) {
		// 	return;
		// }
		const [year, month, day] = date.split('-').map((num) => num.padStart(2, '0'));
		return {
			day,
			month,
			year,
		};
	};

	const handleSubmitExcelData = async () => {
		const payloadArray = [];
		const groupByTitle = _.groupBy(excelTable, 'Reference Id');

		for (let title in groupByTitle) {
			groupByTitle[title].sort((a, b) => dayjs(a['Lease Effective Date (YYYY-MM-DD)']).diff(dayjs(b['Lease Effective Date (YYYY-MM-DD)'])));

			const dataLength = groupByTitle[title].length;
			const leaseChanges = [];
			groupByTitle[title].map((item, index) => {
				const leaseChangeObject = {
					inputChangeMonth: calculateMonthDifference(
						parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']),
						parseAndFormatExcelDate(item['Lease Start Date (YYYY-MM-DD)'])
					),
					inputChangeLeaseTerm: String(item['Lease Term']),
					inputChangeGrossAmount: String(item['Monthly Gross-Rent']),
					inputChangeDiscountRate: String(item['Incremental Borrowing Rate']),
					inputChangeEscalation: String(item['Escalation (%)']),
					paymentFrequency:
						item['Payment Frequency'].toLowerCase() === 'monthly'
							? 'Monthly'
							: item['Payment Frequency'].toLowerCase() === 'quarterly'
								? 'Quarterly'
								: '',
					paymentTime:
						item['Payment Modality'].toLowerCase() === 'advance basis'
							? 'Start'
							: item['Payment Modality'].toLowerCase() === 'accrual basis'
								? 'End'
								: '',

					inputChangeAdvance: String(item['Advance Amount']),
					inputChangeAmortizationPeriod: String(item['Advance Duration']),

					inputChangeEffectiveDate: formatEffectiveDate(parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)'])),
				};
				leaseChanges.push(leaseChangeObject);
				if (index === dataLength - 1) {
					const StartDate = parseAndFormatExcelDate(item['Lease Start Date (YYYY-MM-DD)']);
					const endDate = dayjs(parseAndFormatExcelDate(item['Lease Start Date (YYYY-MM-DD)']))
						.add(+item['Lease Term'], 'month')
						.subtract(1, 'day')
						.format('YYYY-MM-DD');
					const formattedStartDate = formatDate(StartDate);
					const formattedEndDate = formatDate(endDate);
					const { day: startDay, month: startMonth, year: startYear } = getDateParts(dayjs(StartDate).format('YYYY-MM-DD'));

					const obj = {
						leaseTitle: item['Lease Title'],
						leaseType: item['Lease Type'],
						lessorName: item['Lessor Name'],
						paymentFrequency: String(item['Payment Frequency']),
						leaseStartDate: `${formattedStartDate}T00:00:00.000Z`,
						leaseEndDate: formattedEndDate,
						leaseTerm: String(item['Lease Term']),
						escalationFrequency: 'annually',
						grossRent: String(formatDecimal(item['Monthly Gross-Rent'])),
						initialDiscountRate: String(item['Incremental Borrowing Rate']),
						escalationPercentage: String(item['Escalation (%)']),
						paymentModality: String(
							item['Payment Modality'].toLowerCase() === 'advance basis'
								? 'Start'
								: item['Payment Modality'].toLowerCase() === 'accrual basis'
									? 'End'
									: ''
						),
						advanceDuration: String(item['Advance Duration']),
						advanceAmount: String(item['Advance Amount']),
						changes: leaseChanges,
						deletionMarker: true,
						startDay,
						startMonth,
						startYear,
					};
					payloadArray.push(obj);
				}
			});
		}

		// for (let i = 0; i < excelTable.length; i++) {
		// 	let obj = {};
		// 	obj = {
		// 		// activationStatus: 'W-I-P',
		// 		// leaseId: '',
		// 		leaseTitle: excelTable[i]['Lease Title'],
		// 		// leaseName: excelTable[i]['Lease Name'],
		// 		leaseType: excelTable[i]['Lease Type'],
		// 		lessorName: excelTable[i]['Lessor Name'],
		// 		paymentFrequency: String(excelTable[i]['Payment Frequency']),
		// 		leaseStartDate: parseAndFormatExcelDate(excelTable[i]['Lease Start Date (YYYY-MM-DD)']),
		// 		leaseEndDate: dayjs(parseAndFormatExcelDate(excelTable[i]['Lease Start Date (YYYY-MM-DD)'])).add(+excelTable[i]['Lease Term'], 'month').subtract(1, 'day'),
		// 		leaseTerm: String(excelTable[i]['Lease Term']),
		// 		escalationFrequency: 'annually',
		// 		grossRent: String(excelTable[i]['Monthly Gross-Rent']),
		// 		// securityAmount: String(excelTable[i]['Security Deposit']),
		// 		initialDiscountRate: String(excelTable[i]['Incremental Borrowing Rate']),
		// 		escalationPercentage: String(excelTable[i]['Escalation (%)']),
		// 		paymentModality: String(excelTable[i]['Payment Modality']),
		// 		advanceDuration: String(excelTable[i]['Advance Duration']),
		// 		advanceAmount: String(excelTable[i]['Advance Amount']),
		// 		changes: [
		// 			{
		// 				inputChangeMonth:
		// 					calculateMonthDifference(
		// 						parseAndFormatExcelDate(excelTable[i]['Lease Effective Date (YYYY-MM-DD)']),
		// 						parseAndFormatExcelDate(excelTable[i]['Lease Start Date (YYYY-MM-DD)']),
		// 					),
		// 				inputChangeLeaseTerm: String(excelTable[i]['Lease Term']),
		// 				inputChangeGrossAmount: String(excelTable[i]['Monthly Gross-Rent']),
		// 				inputChangeDiscountRate: String(excelTable[i]['Incremental Borrowing Rate']),
		// 				inputChangeEscalation: String(excelTable[i]['Escalation (%)']),
		// 				paymentFrequency: String(excelTable[i]['Payment Frequency']),
		// 				paymentTime: String(excelTable[i]['Payment Modality']),
		//
		// 				inputChangeEffectiveDate: parseAndFormatExcelDate(excelTable[i]['Lease Effective Date (YYYY-MM-DD)']),
		// 			},
		// 		],
		// 	};
		// 	payloadArray.push(obj);

		// }

		const payload = {
			operation: 'add-bulk',
			processCode: state.processCode,
			suffixCode: '',
			data: payloadArray,
		};
		UploadBulkIdentityCase(payload);
	};

	useEffect(() => {
		if (excelData) {
			validateData(excelData);
		}
	}, [excelData]);

	useEffect(() => {
		if (isBulkCaseSuccess) {
			navigate(-1);
		} else if (isBulkCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isBulkCaseSuccess]);

	//initial excel file data setup
	const exportData = [
		{
			// 'Lease Id': '',
			'Reference Id': '',
			'Lease Title': '',
			// 'Lease Name': '',
			'Lease Type': '',
			'Lessor Name': '',
			'Payment Frequency': '',
			'Lease Start Date (YYYY-MM-DD)': '',
			'Lease Effective Date (YYYY-MM-DD)': '',
			'Lease Term': '',
			'Monthly Gross-Rent': '',
			// 'Security Deposit': '',
			'Incremental Borrowing Rate': '',
			'Escalation (%)': '',
			'Payment Modality': '',
			'Advance Amount': '',
			'Advance Duration': '',
		},
	];

	const columns = [
		{
			id: 'referenceId',
			align: 'center',
			disablePadding: true,
			label: 'Reference Id',
		},

		{
			id: 'leaseTitle',
			align: 'center',
			disablePadding: true,
			label: 'Lease Title',
		},

		{
			id: 'leaseType',
			align: 'center',
			disablePadding: true,
			label: 'Lease Type',
		},
		{
			id: 'lessorName',
			align: 'center',
			disablePadding: true,
			label: 'Lessor Name',
		},
		{
			id: 'paymentFrequency',
			align: 'center',
			disablePadding: true,
			label: 'Payment Frequency',
		},
		{
			id: 'leaseStartDate',
			align: 'center',
			disablePadding: true,
			label: 'Lease Start Date (YYYY-MM-DD)',
		},
		{
			id: 'leaseEffectiveDate',
			align: 'center',
			disablePadding: true,
			label: 'Lease Effective Date (YYYY-MM-DD)',
		},
		{
			id: 'leaseTerm',
			align: 'center',
			disablePadding: true,
			label: 'Lease Term',
		},
		{
			id: 'monthlyGrossRent',
			align: 'center',
			disablePadding: true,
			label: 'Monthly Gross-Rent',
		},

		{
			id: 'internalBorrowingRate',
			align: 'center',
			disablePadding: true,
			label: 'Incremental Borrowing Rate',
		},
		{
			id: 'escalation',
			align: 'center',
			disablePadding: true,
			label: 'Escalation (%)',
		},
		{
			id: 'paymentModality',
			align: 'center',
			disablePadding: true,
			label: 'Payment Modality',
		},
		{
			id: 'advanceAmount',
			align: 'center',
			disablePadding: true,
			label: 'Advance Amount',
		},
		{
			id: 'advanceDuration',
			align: 'center',
			disablePadding: true,
			label: 'Advance Duration',
		},
		{
			id: 'lrmAction',
			align: 'center',
			disablePadding: true,
			label: 'Action',
		},
	];

	return (
		<div>
			<p style={{ paddingLeft: '20px' }}>
				To download a demo <img src={excel} alt="excel" width={22} style={{ margin: '0 5px' }} /> file{' '}
				<Button
					size="small"
					type="dashed"
					onClick={(e) => {
						e.stopPropagation();
						// exportExcelFile(exportData, exportDataTypes, 'LRM_BulkUpload.xlsx');
						exportExcelFile(exportData, 'LRM_BulkUpload.xlsx');
					}}
					style={{ color: '#1677ff', borderColor: '#1677ff' }}
				>
					Click Here
				</Button>
			</p>

			<Form
				name="basic"
				layout="vertical"
				labelCol={{
					span: 12,
				}}
				wrapperCol={{
					span: 24,
				}}
				onFinish={onFinish}
				// onFinishFailed={onFinishFailed}
			>
				<Row gutter={[24, 24]}>
					<Col xs={24} sm={24} md={24} xl={24}>
						<Form.Item
							rules={[
								{
									required: true,
								},
							]}
						>
							{!show && (
								<Dragger
									name="file"
									// action="/your-upload-endpoint" // Replace with your actual upload endpoint
									customRequest={({ file }) => {
										handleFileUpload(file, validateData, setShow);
									}}
									showUploadList={false}
									accept=".xlsx, .xls" // Specify the accepted file types (Excel files)
								>
									<p className="ant-upload-drag-icon">
										<InboxOutlined />
									</p>
									<p className="ant-upload-text">Click or drag Excel file to this area to upload</p>
									<p className="ant-upload-hint">Support for .xlsx and .xls files.</p>
								</Dragger>
							)}

							<br></br>

							{show && excelData && (
								<Box>
									<TableContainer
										sx={{
											width: '100%',
											overflowX: 'auto',
											position: 'relative',
											display: 'block',
											maxWidth: '100%',
											'& td, & th': { whiteSpace: 'nowrap' },
										}}
									>
										<Table
											aria-labelledby="tableTitle"
											sx={{
												'& .MuiTableCell-root:first-of-type': {
													pl: 2,
												},
												'& .MuiTableCell-root:last-of-type': {
													pr: 3,
												},
											}}
										>
											<TableHead>
												<TableRow style={{ backgroundColor: '#e5e5e5' }}>
													{columns.map((headCell, index) => (
														<TableCell
															key={index}
															align={headCell.align || 'left'}
															padding={headCell.disablePadding ? 'none' : 'normal'}
														>
															{headCell.label === 'Row No' && (
																<img src={excel} alt="excel" width={22} style={{ marginRight: '5px' }} />
															)}{' '}
															{headCell.label}
														</TableCell>
													))}
												</TableRow>
											</TableHead>

											<TableBody>
												{excelTable?.map((lrm, index, positionMaster) => {
													return (
														<TableRow
															hover
															role="checkbox"
															sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
															tabIndex={-1}
															key={index}
														>
															<TableCell align="center">{lrm['Reference Id']}</TableCell>
															{/*<TableCell align="center">System Generated</TableCell>*/}
															<TableCell align="Left">
																{/* <div style={{ border: lrm['Lease Title'] === '' ? '2px solid red' : '' }}></div>
																<div
																	style={{
																		border: lrm['Lease Title'] === '' ? '2px solid red' : '',
																	}}
																>
																	{lrm['Lease Title'] === '' ? ' Lease Title is required ' : lrm['Lease Title']}
																</div> */}
																{lrm['Lease Title']}
															</TableCell>
															{/* <TableCell align="center">
																<div style={{ border: lrm['Lease Name'] === '' ? '2px solid red' : '' }}>
																	{lrm['Lease Name'] === '' ? ' Lease Name is required ' : lrm['Lease Name']}
																</div>
																{lrm['Lease Name']}
															</TableCell> */}
															<TableCell align="center">
																{/* <div style={{ border: lrm['Lease Type'] === '' ? '2px solid red' : '' }}>
																	{lrm['Lease Type'] === '' ? ' Lease Type is required ' : lrm['Lease Type']}
																</div> */}
																{lrm['Lease Type']}
															</TableCell>
															<TableCell align="Left">
																{/* <div style={{ border: lrm['Lessor Name'] === '' ? '2px solid red' : '' }}>
																	{lrm['Lessor Name'] === '' ? ' Lessor Name is required ' : lrm['Lessor Name']}
																</div> */}
																{lrm['Lessor Name']}
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Payment Frequency'] === '' ||
																			!(
																				lrm['Payment Frequency'].toLowerCase() === 'monthly' ||
																				lrm['Payment Frequency'].toLowerCase() === 'quarterly'
																			)
																				? '2px solid red'
																				: '',
																	}}
																>
																	{lrm['Payment Frequency'] === ''
																		? ' Required '
																		: lrm['Payment Frequency'].toLowerCase() === 'monthly' ||
																			  lrm['Payment Frequency'].toLowerCase() === 'quarterly'
																			? lrm['Payment Frequency']
																			: ' Enter monthly or quarterly as value '}
																</div>
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border: lrm['Lease Start Date (YYYY-MM-DD)'] === '' ? '2px solid red' : '',
																	}}
																>
																	{/* getCurrentMonthFirstDate(parseAndFormatExcelDate(excelTable[i]['Lease Start Date (YYYY-MM-DD)'])) */}
																	{lrm['Lease Start Date (YYYY-MM-DD)'] === ''
																		? ' Required '
																		: formatDate(parseAndFormatExcelDate(lrm['Lease Start Date (YYYY-MM-DD)']))}
																</div>
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Lease Effective Date (YYYY-MM-DD)'] === '' ? '2px solid red' : '',
																	}}
																>
																	{/*  */}
																	{lrm['Lease Effective Date (YYYY-MM-DD)'] === ''
																		? ' Required '
																		: formatDate(
																				parseAndFormatExcelDate(lrm['Lease Effective Date (YYYY-MM-DD)'])
																			)}
																</div>
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Lease Term'] === '' || isNaN(Number(lrm['Lease Term']))
																				? '2px solid red'
																				: '',
																	}}
																>
																	{lrm['Lease Term'] === ''
																		? ' Required '
																		: isNaN(Number(lrm['Lease Term']))
																			? ' Insert a Numeric Value '
																			: lrm['Lease Term']}
																</div>
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Monthly Gross-Rent'] === '' ||
																			isNaN(Number(lrm['Monthly Gross-Rent']))
																				? '2px solid red'
																				: '',
																	}}
																>
																	{lrm['Monthly Gross-Rent'] === ''
																		? ' Required '
																		: isNaN(Number(lrm['Monthly Gross-Rent']))
																			? ' Insert a Numeric Value '
																			: formatNumber(lrm['Monthly Gross-Rent'], 2)}
																</div>
															</TableCell>
															{/* <TableCell align="center">
																<div style={{ border: lrm['Security Deposit'] === '' ? '2px solid red' : '' }}>
																	{lrm['Security Deposit'] === ''
																		? ' Security Deposit is required '
																		: lrm['Security Deposit']}
																</div>
																{lrm['Security Deposit']}
															</TableCell> */}
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Incremental Borrowing Rate'] === '' ||
																			isNaN(Number(lrm['Incremental Borrowing Rate']))
																				? '2px solid red'
																				: '',
																	}}
																>
																	{lrm['Incremental Borrowing Rate'] === ''
																		? ' Required '
																		: isNaN(Number(lrm['Incremental Borrowing Rate']))
																			? ' Insert a Numeric Value '
																			: lrm['Incremental Borrowing Rate']}
																</div>
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Escalation (%)'] === '' || isNaN(Number(lrm['Escalation (%)']))
																				? '2px solid red'
																				: '',
																	}}
																>
																	{lrm['Escalation (%)'] === ''
																		? ' Required '
																		: isNaN(Number(lrm['Escalation (%)']))
																			? ' Insert a Numeric Value '
																			: lrm['Escalation (%)']}
																</div>
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Payment Modality'] === '' ||
																			!(
																				lrm['Payment Modality'].toLowerCase() === 'advance basis' ||
																				lrm['Payment Modality'].toLowerCase() === 'accrual basis'
																			)
																				? '2px solid red'
																				: '',
																	}}
																>
																	{lrm['Payment Modality'] === ''
																		? ' Required '
																		: lrm['Payment Modality'].toLowerCase() === 'advance basis'
																			? 'Advance Basis'
																			: lrm['Payment Modality'].toLowerCase() === 'accrual basis'
																				? 'Accrual Basis'
																				: // :	 lrm['Payment Modality']
																					' Enter Advance Basis or Accrual Basis as value '}
																</div>
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Advance Amount'] === '' || isNaN(Number(lrm['Advance Amount']))
																				? '2px solid red'
																				: '',
																	}}
																>
																	{lrm['Advance Amount'] === ''
																		? ' Required '
																		: isNaN(Number(lrm['Advance Amount']))
																			? ' Insert a Numeric Value '
																			: formatNumber(lrm['Advance Amount'])}
																</div>
															</TableCell>
															<TableCell align="center">
																<div
																	style={{
																		border:
																			lrm['Advance Duration'] === '' || isNaN(Number(lrm['Advance Duration']))
																				? '2px solid red'
																				: '',
																	}}
																>
																	{lrm['Advance Duration'] === ''
																		? ' Required '
																		: isNaN(Number(lrm['Advance Duration']))
																			? ' Insert a Numeric Value '
																			: lrm['Advance Duration']}
																</div>
															</TableCell>
															<TableCell key={positionMaster?.id} align="center">
																{' '}
																<div>
																	{lrm['Remarks'].valid ? (
																		<CheckSquareOutlined
																			size="large"
																			style={{
																				fontSize: '20px',
																				color: theme.palette.lynTheme.success,
																			}}
																		/>
																	) : (
																		<>
																			<Popover
																				trigger="focus"
																				placement="topLeft"
																				content={
																					<ErrorModal
																						modalData={transformErrors(lrm['Remarks'], +lrm['Data No.'])}
																					/>
																				}
																			>
																				<Button
																					style={{
																						backgroundColor: theme.palette.error?.main || 'red',
																						marginRight: '10px',
																					}}
																					type="primary"
																				>
																					Show Errors
																				</Button>
																			</Popover>
																		</>
																	)}
																</div>{' '}
															</TableCell>
														</TableRow>
													);
												})}
											</TableBody>
										</Table>
									</TableContainer>
								</Box>
							)}
						</Form.Item>
					</Col>

					<Col xs={24} sm={24} md={24} xl={24}>
						<Flex justify="flex-end" align="flex-end">
							{show && (
								<>
									{/* {filesubmitButton && (
										<Button
											style={{ backgroundColor: theme.palette.lynTheme.success, marginRight: '10px' }}
											type="primary"
											onClick={(e) => {
												e.preventDefault();

												setRefetchData((prev) => !prev);
												validateData(excelData);
											}}
										>
											Revalidate
										</Button>
									)} */}
									<Button
										style={{ backgroundColor: theme.palette.error?.main, marginRight: '10px' }}
										type="primary"
										onClick={(e) => {
											e.preventDefault();
											setExcelTable([]);
											setShow(false);
										}}
									>
										Cancel
									</Button>

									<Button
										disabled={filesubmitButton}
										style={{ backgroundColor: filesubmitButton ? '' : theme.palette.lynTheme.submit }}
										type="primary"
										onClick={(e) => {
											e.preventDefault();
											handleExcelSubmit(excelTable);
										}}
									>
										Submit
									</Button>
								</>
							)}
						</Flex>
					</Col>
				</Row>
			</Form>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					setShowModal={setShowModal}
					modalData={modalInfo}
					handleSubmit={handleSubmitExcelData}
				/>
			)}
		</div>
	);
};

export default LeaseBulkUpload;
